import { toNumber, isNaN, pipe, curry } from "lodash/fp";

const queryString = require("qs");

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return (
    s4() +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    s4() +
    s4()
  );
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function transformLowdash(word) {
  return word
    .split("_")
    .map(capitalizeFirstLetter)
    .join(" ");
}

export const continueMessages = {
  pending_diagnostic: "Start Diagnostic",
  in_diagnostic: "Confirm Diagnostic",
  approve_diagnostic: "Approve Diagnostic",
  customer_confirmation_needed: "Confirm Your Contract",
  waiting_for_payment: "Mark As Paid",
  waiting_for_service: "Start Service",
  in_service: "Complete Service",
  // waiting_for_invoice: "Mark As Invoice Created",
  waiting_for_pickup: "Mark As Picked Up"
};

export const continueKeys = {
  approve_diagnostic: "diagnostic_completed",
  // waiting_for_invoice: "invoice",
  waiting_for_payment: "paid",
  waiting_for_pickup: "picked_up"
};

export const statuses = [
  "pending_diagnostic",
  "in_diagnostic",
  "approve_diagnostic",
  "customer_confirmation_needed",
  "waiting_for_payment",
  "waiting_for_service",
  "in_service",
  // "waiting_for_invoice",
  "waiting_for_pickup",
  "completed",
  "hold",
  "waiting_for_parts"
];

export const objectToQueryString = queryObject => {
  let stringified = queryString.stringify(queryObject);
  return stringified ? `?${stringified}` : "";
};

export const invalidNumber = number =>
  pipe(
    toNumber,
    isNaN,
    isNotNumber => (isNotNumber ? isNotNumber : number < 0)
  )(number);

export const onChangeCheckbox = ({ name, values, setValues }) => () =>
  setValues(Object.assign({}, values, { [name]: !values[name] }));

export const trace = curry((tag, f) => {
  console.trace(tag, f);
  return f;
});

export const getBreakpointFromWidth = width => {
  switch (true) {
    case width >= 1200:
      return "xl";
    case width >= 992:
      return "lg";
    case width >= 768:
      return "md";
    case width >= 576:
      return "sm";
    default:
      return "xs";
  }
};
